<script setup>
defineProps({
  variant: {
    type: String,
    default: 'default'
  }
});

const classes = {
  warning: 'text-warning',
  danger: 'text-red-600',
  default: 'text-grey-900'
};
</script>

<template>
  <div :class="classes[variant]" class="mt-1 text-xs">
    <slot />
  </div>
</template>
